import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';

/** Edits the existing JSON control directly, keeping advanced JSON and audience controls in sync. */
@Component({
  selector: 'app-offer-audiences', standalone: true, imports: [CommonModule, MatCheckboxModule],
  template: `<fieldset><legend>Audience</legend>
    <mat-checkbox [checked]="includes('customers')" [disabled]="!document" (change)="toggle('customers', $event.checked)">Customers</mat-checkbox>
    <mat-checkbox [checked]="includes('companies')" [disabled]="!document" (change)="toggle('companies', $event.checked)">Companies</mat-checkbox>
    <p *ngIf="!document" role="alert">Correct the JSON before changing its audience.</p>
    <p>Company offers are enabled separately from employee products. Neither selected disables both audiences.</p>
    <p *ngIf="offer && includes('companies')">Company offers need a vendor product mapping and a literal HTTPS external-link action. Customer templates and enrollment actions are not supported.</p>
  </fieldset>`,
  styles: [`fieldset { border: 1px solid #d5dae2; border-radius: 8px; margin: 12px 0 20px; padding: 12px 16px; }
    mat-checkbox { margin-right: 24px; } p { font-size: 12px; color: #596173; margin: 10px 0 0; }`],
})
export class OfferAudiencesComponent {
  @Input() control!: AbstractControl;
  @Input() offer = false;
  get document(): any {
    const value = this.control?.value;
    try {
      const parsed = (typeof value === 'string' ? JSON.parse(value || '{}') : value) ?? {};
      return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : null;
    } catch (_) { return null; }
  }
  includes(audience: string): boolean {
    const document = this.document;
    if (!document) { return false; }
    if (!Object.prototype.hasOwnProperty.call(document, 'audiences')) { return audience === 'customers'; }
    return Array.isArray(document.audiences) && document.audiences.includes(audience);
  }
  toggle(audience: string, checked: boolean): void {
    const document = this.document;
    if (!document) { return; }
    const audiences = ['customers', 'companies'].filter(item => item === audience ? checked : this.includes(item));
    this.control.setValue({ ...document, audiences });
    this.control.markAsDirty();
  }
}
